<template>
  <el-row class="el-title c-white-background">
    <MainNavBarWapV2 :object-data="infoHeader" />
    <div class="container colum pc">
      <el-row class="list-shop__header top-spacing">
        <el-col :sm="24" class="custom-el-input">
          <el-col
            class="flex justify-content-center"
            v-for="(url, i) in urlData"
            :key="i"
            :sm="24"
          >
            <img :src="url" alt="" />
          </el-col>
        </el-col>
      </el-row>
    </div>
    <div class="mobile">
      <el-row class="list-shop__header top-spacing">
        <el-col :sm="24" class="custom-el-input">
          <el-col v-for="(url, i) in urlData" :key="i" :sm="24">
            <img :src="url" alt="" />
          </el-col>
        </el-col>
      </el-row>
    </div>
  </el-row>
</template>
<script>
import MainNavBarWapV2 from "@/layout/WapV2/MainNavBar.vue";
import { LIST_POLICY, LIST_PROD_BANK } from "@/constant/contant";

export default {
  name: "iframe-link-page",
  computed: {},
  components: {
    MainNavBarWapV2
  },
  props: {},

  data() {
    return {
      loadingData: true,
      infoHeader: {
        title: "",
        isShowHomeIcon: true,
        isShowMenu: true
      },
      dataMenu: {
        rules: {
          label: this.$t("wap.text114"),
          link: [
            require("@/assets/img/rules/ĐIỀU KHOẢN HOÃN HỦY SÂN GOLF-0.jpg"),
            require("@/assets/img/rules/ĐIỀU KHOẢN HOÃN HỦY SÂN GOLF-1.jpg"),
            require("@/assets/img/rules/ĐIỀU KHOẢN HOÃN HỦY SÂN GOLF-2.jpg")
          ]
        },
        policy: {
          label: this.$t("wap.text115"),
          link: [require("@/assets/img/rules/hang-tv.png")]
        },
        "service-nab": {
          label: this.$t("wap.text111"),
          link: [
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-0.jpg"),
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-1.jpg"),
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-2.jpg"),
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-3.jpg"),
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-4.jpg"),
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-5.jpg"),
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-6.jpg"),
            require("@/assets/img/bank/nab/DKDK CHI TIET CHUONG TRINH UU DAI DAC QUYEN THE TIN DỤNG HAPPY GOLF 12.07.2023-hình ảnh-7.jpg")
          ]
        },
        "service-stb": {
          label: this.$t("wap.text112"),
          link: [
            require("@/assets/img/bank/stb/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-0.jpg"),
            require("@/assets/img/bank/stb/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-1.jpg"),
            require("@/assets/img/bank/stb/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-2.jpg"),
            require("@/assets/img/bank/stb/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-3.jpg"),
            require("@/assets/img/bank/stb/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-4.jpg")
          ]
        },
        "service-tech": {
          label: this.$t("wap.text113"),
          link: [
            require("@/assets/img/bank/tech/the-le-chi-tiet-golf-private-26072024-hình ảnh-0.jpg"),
            require("@/assets/img/bank/tech/the-le-chi-tiet-golf-private-26072024-hình ảnh-1.jpg"),
            require("@/assets/img/bank/tech/the-le-chi-tiet-golf-private-26072024-hình ảnh-2.jpg"),
            require("@/assets/img/bank/tech/the-le-chi-tiet-golf-private-26072024-hình ảnh-3.jpg"),
            require("@/assets/img/bank/tech/the-le-chi-tiet-golf-private-26072024-hình ảnh-4.jpg")
          ]
        }
      },
      isLoading: true,
      urlData: []
    };
  },
  created() {
    setTimeout(() => {
      this.loadingData = false;
    }, 1500);
    this.getInfo(this.$route.query.type);
  },
  watch: {
    "$route.query.type"(newValue, oldValue) {
      this.getInfo(newValue);
    }
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    getInfo(type) {
      const data = this.dataMenu[type];
      if (!data) this.$route.push("/wap");
      this.infoHeader = {
        title: data.label,
        isShowHomeIcon: true,
        isShowMenu: true
      };
      this.urlData = data.link;
    }
  }
};
</script>

<style scoped>
.top-spacing {
  padding-top: 80px;
}
.mobile {
  display: none;
}
.pc {
  display: block;
}
@media screen and (min-width: 0px) and (max-width: 901px) {
  .top-spacing {
    padding-top: 60px;
  }
  .mobile {
    display: block;
  }
  .pc {
    display: none;
  }
}
</style>
